import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import FormulaEditPopoverForm from "../formula/components/form/formula-edit-popover-form";

export default function CustomFieldFormula(props) {
    return (
        <FormRow elementClass="formula-element" label="Formula">
            <FormulaEditPopoverForm form={props.form}/>
            <FormError className="formula-error" form={props.form} name="formula"/>
        </FormRow>
    );
}

CustomFieldFormula.propTypes = {
    form: PropTypes.object
}